import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {
    getTaxasTurno(context, dados) {
        if((!dados.pagina) || (!dados.quantidadePorPagina)) {
            dados.pagina = 1;
            dados.quantidadePorPagina = 25;
        }
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("taxasTurno/access/listar", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },    
    getTaxasTurnoBox(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("taxasTurno/access/listaBox", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getTaxaTurno(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("taxasTurno/access/obter", {ID_TAXA: dados.id, componente: dados.componente}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    deleteTaxaTurno(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("taxasTurno/access/excluir", {ID_TAXA: dados.id, componente: dados.componente}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    postTaxaTurno(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("taxasTurno/access/salvar", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getTaxasTurnoTurnos(context, id) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("taxasTurno/access/listarTurnos", id).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getTaxasTurnoPlanos(context, id) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("taxasTurno/access/listarPlanos", id).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getTaxasTurnoProdutos(context, id) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("taxasTurno/access/listarProdutos", id).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getTaxasTurnoCategoriasLocal(context, id) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("taxasTurno/access/listarCategoriasLocal", id).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }

};

export default {
    state,
    actions,
    mutations,
    getters
};